/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { AlertContext, AppContext, ModalContext, ToastrContext } from '../../../contexts';
import { logout } from '../../../pages/Login/actions';
import { analytics } from '../../../utils/firebase';
import { router } from '../../../utils/routeBuilder';
import { getUserData } from '../../../utils/storage';
import Banner from '../../elements/Banner';
import Button from '../../elements/Button';
import MenuDropdown from '../../elements/MenuDropdown';
import Modal from '../../elements/Modal';
import IconAktivasiManual from '../../icons/IconAkativasiManual';
import IconArrowDown from '../../icons/IconArrowDown';
import IconAturHET from '../../icons/IconAturHET';
import IconAudit from '../../icons/IconAudit';
import IconFailed from '../../icons/IconFailed';
import IconInfoRevition from '../../icons/IconInfoRevition';
import IconLogout from '../../icons/IconLogout';
import IconManagementMerchant from '../../icons/IconManagementMerchant';
import IconManagementUser from '../../icons/IconManagementUser';
import IconMyptmActivation from '../../icons/IconMyptmActivation';
import IconPermission from '../../icons/IconPermission';
import IconRegistrasiPangkalan from '../../icons/IconRegistrasiPangkalan';
import IconRole from '../../icons/IconRole';
import IconSettingFaq from '../../icons/IconSettingFaq';
import IconSuccess from '../../icons/IconSuccess';
import IconTerm from '../../icons/IconTerm';
import IconUser from '../../icons/IconUser';
import IconVerification from '../../icons/IconVerification';
import IconSettingMerchant from '../../icons/IconsettingMerchant';
import { fetchDetailUser } from './actions';
import styles from './styles.scoped.css';
import { dynamicSort } from '../../../utils/validation';
import IconSettingMap from '../../icons/IconSettingMap';
import IconNotification from '../../icons/IconNotification';
import LogoMap from '../../icons/logo';

moment.locale('id');
export default function PageBase({ children }) {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const { dataProductCategories, dataDetailUser } = useSelector(
    (s) => s.pageBase
  );

  const noAuthRoutes = ['/login', '/forgot-password', '/reset-password'];
  const noAuth = noAuthRoutes.some((r) => pathname.match(r));


  let navsData = [
    {
      name: 'Registrasi Pangkalan',
      to: '/registrasi-pangkalan',
      icon: <IconRegistrasiPangkalan />,
    },
    { name: 'Atur Harga Produk', to: '/price', icon: <IconAturHET /> },
    { name: 'Pengaturan FAQ', to: '/faq', icon: <IconSettingFaq /> },
  ];

  const [navs, setNavs] = useState(navsData);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    body.style.backgroundColor = noAuthRoutes.includes(pathname)
      ? '#FFFFFF'
      : '#F5F6FA';
  }, [pathname]);

  useEffect(() => {
    if (!noAuth) {
      const app = document.getElementById('app');
      app.className = 'pagebase';
    }
  }, []);

  useEffect(() => {
    if (getUserData()?.adminId) {
      dispatch(fetchDetailUser());
    }
  }, []);

  const filterItems = (arr, query) => {
    return arr?.filter((el) => el?.type?.includes(query));
  };

  useEffect(() => {
    const permission = dataDetailUser?.permitions?.map((object) => {
      const icon = router.find((route) => route.path === object.path)?.icon;
      const type = router.find((route) => route.path === object.path)?.menu;
      const serialNumber = router.find((route) => route.path === object.path)?.serialNumber;

      const menu = {
        name: object.name,
        to: object.path,
        icon: icon,
        type,
        serialNumber
      };
      return menu;
    });

    const childrenMenuManajemenMerchant = filterItems(permission, 'management-merchant');
    const childrenMenuManajemenUser = filterItems(permission, 'management-user');
    const childrenMenuSettingMap = filterItems(permission, 'setting-map');

    const manajemenMerchant =
      childrenMenuManajemenMerchant.length > 0
        ? [
          {
            name: 'Manajemen Pangkalan LPG 3 Kg',
            child: childrenMenuManajemenMerchant.sort(dynamicSort('serialNumber')),
            icon: <IconManagementMerchant />,
            show: pathname.includes('/merchant/'),
          },
        ]
        : [];

    const manajemenUser =
      childrenMenuManajemenUser.length > 0
        ? [
          {
            name: 'Manajemen User',
            child: childrenMenuManajemenUser.sort(dynamicSort('serialNumber')),
            icon: <IconManagementUser />,
            show: pathname.includes('/user-management/'),
          },
        ]
        : [];

    const settingMap =
        childrenMenuSettingMap.length > 0
          ? [
            {
              name: 'Pengaturan MAP',
              child: childrenMenuSettingMap.sort(dynamicSort('serialNumber')),
              icon: <IconSettingMap />,
              show: pathname.includes('/merchant/'),
            },
          ]
          : [];
    const navs = [
      ...filterItems(permission, 'price'),
      // ...filterItems(permission, 'faq'),
      // ...filterItems(permission, 'term'),
      ...settingMap,
      ...manajemenMerchant,
      ...manajemenUser,
    ];
    setNavs(navs);
  }, [dataProductCategories, dataDetailUser]);

  const { content, setContent } = useContext(ModalContext);
  const { alert, setAlert } = useContext(AlertContext);
  const { toastr } = useContext(ToastrContext);

  const closeModal = (e) => {
    if (e.target === e.currentTarget) {
      setContent(null);
    }
  };

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    if (content) {
      body.className = 'modal-open';
    }
    if (alert) {
      body.className = 'alert-open';
      // setTimeout(() => {
      //   setAlert(null);
      // }, 2500);
    } else {
      setAlert(null);
    }
    if (!alert && !content) {
      body.className = '';
    }
  }, [content, alert]);

  if (noAuth) {
    return (
      <>
        {children}
        {toastr?.visible ? (
          <div className={styles.alert}>
            <Banner
              {...toastr}
              icon={
                toastr.type === 'success' ? (
                  <IconSuccess className={styles.icon} />
                ) : (
                  <IconFailed />
                )
              }
            />
          </div>
        ) : null}
        <div className="modal" onClick={closeModal}>
          {content}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="alert">{alert}</div>
      <aside className={styles.aside}>
        <div className={styles.logo}>
          <LogoMap className={styles.logoMap} />
          <div>
            <p>ADMIN CONSOLE</p>
            <h5>SUBSIDI TEPAT</h5>
            <p className={styles.thirdLine}>MYPERTAMINA LPG 3 KG</p>
          </div>
        </div>
        <nav>
          {navs.map((n, idx) => {
            let child = [];
            const linkProps = {
              onClick: () => {
                if (n.to && !n.child) {
                  analytics.logEvent('click_menu', {
                    target: n.to,
                    name: n.name,
                  });
                } else {
                  analytics.logEvent('click_submenu', {
                    target: n.to,
                    name: n.name,
                  });
                }
              },
            };
            if (n.child) {
              const linkChild = n.child.map((i, idy) => (
                <Link
                  className={[
                    styles['link-child'],
                    (location.pathname.includes(i.to) ||
                      location.pathname === i.sub) &&
                      styles.active,
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  key={`${idx}${idy}`}
                  to={i.to}
                >
                  {i.icon}
                  {i.name}
                </Link>
              ));
              child = [...child, linkChild];
              linkProps.onClick = () => {
                n.show = !n.show;
              };
            }
            return (
              <React.Fragment key={idx}>
                <Link
                  className={
                    (location.pathname !== '/'
                      ? location.pathname.includes(n.to) && n.to !== '/'
                      : location.pathname === n.to) ||
                    location.pathname === n.sub
                      ? styles.active
                      : undefined
                  }
                  {...linkProps}
                  r={n.to}
                  to={n.to && !n.child ? n.to : '#'}
                >
                  {n.icon}
                  {n.name}
                  {n.child && (
                    <img
                      alt="Show More"
                      className={styles.arrow}
                      src={n.show ? 'assets/ic-up.svg' : 'assets/ic-down.svg'}
                    />
                  )}
                </Link>
                {n.show && <div>{child}</div>}
              </React.Fragment>
            );
          })}
        </nav>
        <div className={styles.helpdesk}>
          Butuh bantuan?
          <br />
          Hubungi kami melalui email
          <br />
          <a href="mailto:helpdesk135@pertamina.com">
            helpdesk135@pertamina.com
          </a>
        </div>
      </aside>
      <div className={styles.children} id="children-container">
        {children}
      </div>
      <div className="modal" onClick={closeModal}>
        {content}
      </div>
      <ModalLogout
        onClick={() => {
          analytics.logEvent('confirm_logout', {
            from_path: location.pathname,
          });
          dispatch(logout());
        }}
        onClose={() => {
          analytics.logEvent('cancel_logout', {
            to_path: location.pathname,
          });
          setModal(false);
        }}
        open={modal}
      />
      <Nav />
    </>
  );
}

PageBase.defaultProps = {
  children: null,
};

PageBase.propTypes = {
  children: PropTypes.node,
};
export function ModalLogout({ open, onClose, onClick }) {
  return (
    <Modal className={styles.modal} onClose={onClose} open={open}>
      <h3>Apakah Anda yakin ingin keluar?</h3>
      <footer>
        <Button onClick={onClose} outlined>
          Batal
        </Button>
        <Button onClick={onClick} style={'blue'}>
          Keluar
        </Button>
      </footer>
    </Modal>
  );
}

ModalLogout.defaultProps = {
  onClick: () => {},
  onClose: () => {},
  open: false,
};

ModalLogout.propTypes = {
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export function renderIconBreadcrumbs() {
  const { pathname } = useLocation();
  const listIcon = [
    {
      icon: <IconRegistrasiPangkalan className={styles.breadCrumbsIcon} />,
      path: '/registrasi-pangkalan',
    },
    {
      icon: <IconAturHET className={styles.breadCrumbsIcon} />,
      path: '/price',
    },
    {
      icon: <IconSettingFaq className={styles.breadCrumbsIcon} />,
      path: '/faq',
    },
    {
      icon: <IconAudit className={styles.breadCrumbsIcon} />,
      path: '/user-management/audit-log',
    },
    {
      icon: <IconVerification className={styles.breadCrumbsIcon} />,
      path: '/merchant/verifikasi-data-merchant',
    },
    {
      icon: <IconVerification className={styles.breadCrumbsIcon} />,
      path: '/merchant/detail-verifikasi-data-merchant',
    },
    {
      icon: <IconSettingMerchant className={styles.breadCrumbsIcon} />,
      path: '/merchant/setting-data-merchant',
    },
    {
      icon: <IconSettingMerchant className={styles.breadCrumbsIcon} />,
      path: '/merchant/detail-setting-data-merchant',
    },
    {
      icon: <IconSettingMerchant className={styles.breadCrumbsIcon} />,
      path: '/merchant/edit-setting-data-merchant',
    },
    {
      icon: <IconMyptmActivation className={styles.breadCrumbsIcon} />,
      path: '/merchant/aktivasi-mypertamina',
    },
    {
      icon: <IconUser className={styles.breadCrumbsIcon} />,
      path: '/user-management/user',
    },
    {
      icon: <IconPermission className={styles.breadCrumbsIcon} />,
      path: '/user-management/permission',
    },
    {
      icon: <IconRole className={styles.breadCrumbsIcon} />,
      path: '/user-management/role',
    },
    {
      icon: <IconAktivasiManual className={styles.breadCrumbsIcon} />,
      path: '/merchant/aktivasi-pencatatan-manual',
    },
    {
      icon: <IconTerm className={styles.breadCrumbsIcon} />,
      path: '/term-condition',
    },
    {
      icon: <IconNotification className={styles.breadCrumbsIcon} />,
      path: '/notification',
    },
  ];

  return (
    <>
      {listIcon.map((val) => {
        if (pathname.includes(val.path)) {
          return val.icon;
        }
      })}
    </>
  );
}

export function Nav() {
  const { breadcrumbs } = useContext(AppContext);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const {
    dataSubmitFaq,
    dataDeleteFaq,
    dataSubmitUpdateFaq,
    isLoadingSubmitFaq,
    isLoadingSubmitUpdateFaq,
    isLoadingDeleteFaq,
  } = useSelector((s) => s.faq);
  const {
    dataSubmitPermission,
    dataSubmitUpdatePermission,
    isLoadingSubmitPermission,
    isLoadingSubmitUpdatePermission,
    messageSubmitPermission,
    messageSubmitUpdatePermission,
  } = useSelector((s) => s.permission);

  const {
    dataSubmitRole,
    dataSubmitUpdateRole,
    isLoadingSubmitRole,
    isLoadingSubmitUpdateRole,
    messageSubmitRole,
    messageSubmitUpdateRole,
  } = useSelector((s) => s.role);

  const {
    deleteNotification
  } = useSelector((s) => s.notification);

  const { isLoadingUpdateTermCondition, dataUpdateTermCondition } = useSelector(
    (s) => s.termCondition
  );

  const { isLoadingSubmitAutoApprove, dataSubmitAutoApprove } = useSelector(
    (s) => s.manualLoggingActivation
  );


  const { isOverLimitRows } = useSelector((s) => s.merchantVerification);
  const {
    suspend,
    edit: editMerchant,
    resend,
    deactivate,
    bank: bankSetting,
  } = useSelector((state) => state.merchantSetting);
  const { download, activation } = useSelector(
    (state) => state.myptmActivation
  );

  const { dataDetailUser } = useSelector((s) => s.pageBase);

  const bcs = [...breadcrumbs];
  const [modal, setModal] = useState(false);
  const { toastr, setToastr } = useContext(ToastrContext);

  useEffect(() => {
    if (dataSubmitFaq && !isLoadingSubmitFaq) {
      setToastr({
        desc: 'FAQ Berhasil ditambah',
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitFaq, isLoadingSubmitFaq]);

  useEffect(() => {
    if (deleteNotification?.success && !deleteNotification?.loading) {
      setToastr({
        desc: 'Notifikasi Berhasil dihapus',
        type: 'success',
        visible: true,
      });
    }else if(!deleteNotification?.success && !deleteNotification?.loading
        && deleteNotification?.message) {
      setToastr({
        desc:  deleteNotification?.message,
        type: 'danger',
        visible: true,
      });
    }
  }, [deleteNotification]);

  useEffect(() => {
    if (dataSubmitUpdateFaq && !isLoadingSubmitUpdateFaq) {
      setToastr({
        desc: 'FAQ Berhasil diubah',
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitUpdateFaq, isLoadingSubmitUpdateFaq]);

  useEffect(() => {
    if (dataUpdateTermCondition && !isLoadingUpdateTermCondition) {
      setToastr({
        desc: 'Syarat & Ketentuan Berhasil diubah',
        type: 'success',
        visible: true,
      });
    }
  }, [dataUpdateTermCondition, isLoadingUpdateTermCondition]);

  useEffect(() => {
    if (dataDeleteFaq && !isLoadingDeleteFaq) {
      setToastr({
        desc: 'FAQ Berhasil dihapus',
        type: 'success',
        visible: true,
      });
    }
  }, [dataDeleteFaq, isLoadingDeleteFaq]);

  useEffect(() => {
    if (dataSubmitPermission && !isLoadingSubmitPermission) {
      setToastr({
        desc: <>
          <span className={styles.toastrMessage}>
          Berhasil menambahkan Permission{' '}
          </span>{' '}
          <b>{messageSubmitPermission}</b>
        </>,
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitPermission, isLoadingSubmitPermission]);

  useEffect(() => {
    if (dataSubmitUpdatePermission && !isLoadingSubmitUpdatePermission) {
      setToastr({
        desc: <>
          <span className={styles.toastrMessage}>
          Berhasil mengubah Permission{' '}
          </span>{' '}
          <b>{messageSubmitUpdatePermission}</b>
        </>,
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitUpdatePermission, isLoadingSubmitUpdatePermission]);

  useEffect(() => {
    if (dataSubmitRole && !isLoadingSubmitRole) {
      setToastr({
        desc: <>
          <span className={styles.toastrMessage}>
          Berhasil menambahkan Role{' '}
          </span>{' '}
          <b>{messageSubmitRole}</b>
        </>,
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitRole, isLoadingSubmitRole]);

  useEffect(() => {
    if (dataSubmitUpdateRole && !isLoadingSubmitUpdateRole) {
      setToastr({
        desc: <>
          <span className={styles.toastrMessage}>
          Berhasil mengubah Role{' '}
          </span>{' '}
          <b>{messageSubmitUpdateRole}</b>
        </>,
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitUpdateRole, isLoadingSubmitUpdateRole]);

  useEffect(() => {
    if(dataSubmitAutoApprove && !isLoadingSubmitAutoApprove){
      setToastr({
        desc: dataSubmitAutoApprove === 'all' ?
          <>
            <span className={styles.toastrMessage}>
          Berhasil mengubah pengaturan sekaligus
            </span>
          </> :
          <>
            <span className={styles.toastrMessage}>
        Berhasil mengubah pengaturan untuk Kelurahan
            </span> {' '}
            <b>{dataSubmitAutoApprove}</b>
          </>,
        type: 'success',
        visible: true,
      });
    }
  },[isLoadingSubmitAutoApprove, dataSubmitAutoApprove]);

  useEffect(() => {
    if (
      !dataSubmitPermission &&
      messageSubmitPermission &&
      !isLoadingSubmitPermission
    ) {
      setToastr({
        desc: messageSubmitPermission,
        type: 'danger',
        visible: true,
      });
    }
  }, [isLoadingSubmitPermission]);

  useEffect(() => {
    if (!dataSubmitRole && messageSubmitRole && !isLoadingSubmitRole) {
      setToastr({
        desc: messageSubmitRole,
        type: 'danger',
        visible: true,
      });
    }
  }, [isLoadingSubmitRole]);

  useEffect(() => {
    if (isOverLimitRows.showAlert && isOverLimitRows.rowsSelected > 20) {
      setToastr({
        desc: <>
          <span className={styles.dangerToastr}>
          Batas maksimal yang dapat dipilih hanya <b>20</b> pangkalan LPG 3 kg
          </span>
        </>,
        type: 'danger',
        visible: true,
      });
    }
  }, [isOverLimitRows]);

  useEffect(() => {
    if (suspend.message) {
      setToastr({
        desc: suspend.message,
        type: suspend.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [suspend.success, suspend.message]);

  useEffect(() => {
    if (resend.message) {
      setToastr({
        desc: resend.message,
        type: resend.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [resend.success, resend.message]);

  useEffect(() => {
    if (bankSetting.message) {
      setToastr({
        desc: bankSetting.message,
        type: bankSetting.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [bankSetting.success, bankSetting.message]);

  useEffect(() => {
    if (editMerchant.message) {
      setToastr({
        desc: editMerchant.message,
        type: editMerchant.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [editMerchant.success, editMerchant.message]);

  useEffect(() => {
    if (deactivate.message) {
      setToastr({
        desc: deactivate.message,
        type: deactivate.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [deactivate.success, deactivate.message]);

  useEffect(() => {
    if (download.message) {
      setToastr({
        desc: download.message,
        type: download.toastrType,
        visible: true,
      });
    }
  }, [download.success, download.message, download.toastrType]);

  useEffect(() => {
    if (activation.message) {
      setToastr({
        desc: activation.message,
        type: activation.toastrType,
        visible: true,
      });
    }
  }, [activation.success, activation.message, activation.toastrType]);

  const listSettings = [
    {
      name: 'Log out',
      onClick: () => {
        analytics.logEvent('click_logout', {
          from_path: location.pathname,
        });
        setModal(true);
      },
      icon: <IconLogout />,
    },
  ];

  return (
    <header className={styles.root}>
      <div className={styles.header}>
        <div className={styles.top}>
          <span />
          <div className={styles.containerRight}>
            <div className={styles.row}>
              <span>{dataDetailUser.email}</span>
              <small>{dataDetailUser.name}</small>
            </div>
            <MenuDropdown listDropDown={listSettings} position="bottom-end">
              <IconArrowDown />
            </MenuDropdown>
          </div>
        </div>
        <div className={styles.breadcrumbs}>
          <span>{renderIconBreadcrumbs()}</span>
          {bcs.reduce((acc, b, idx) => {
            if (idx + 1 === bcs.length) {
              return [
                ...acc,
                idx ? (
                  <React.Fragment key={`s${idx}`}>&nbsp;</React.Fragment>
                ) : (
                  ''
                ),
                <p key={idx}>{b}</p>,
              ];
            }
            return [
              ...acc,
              <Link key={idx} to={b?.to ? b.to : `/${pathname.split('/')?.[idx+1]}`}>
                {b?.name ? b.name : b}&nbsp;
              </Link>,
              <React.Fragment key={`s${idx}`}>&nbsp;/&nbsp;</React.Fragment>,
            ];
          }, [])}

          {toastr?.visible ? (
            <div className={styles.alert}>
              <Banner
                {...toastr}
                icon={
                  toastr.type === 'success' ? (
                    <IconSuccess className={styles.icon} />
                  ) : toastr.type === 'info' ? (
                    <IconInfoRevition />
                  ) : (
                    <IconFailed />
                  )
                }
              />
            </div>
          ) : null}
        </div>
      </div>
      <ModalLogout
        onClick={() => {
          analytics.logEvent('confirm_logout', {
            from_path: location.pathname,
          });
          dispatch(logout());
        }}
        onClose={() => {
          analytics.logEvent('cancel_logout', {
            to_path: location.pathname,
          });
          setModal(false);
        }}
        open={modal}
      />
    </header>
  );
}
